<div class="data-setup-common-page">
    <section class="data-setup-banner-section">
        <picture class="banner-image-container">
            <source width="1024" height="324" srcset='assets/img/banners/data-setup-banner-responsive.webp'
                media="(max-width: 1024.9px)" type="image/webp">
            <source width="1024" height="324" srcset='assets/img/banners/data-setup-banner-responsive.png'
                media="(max-width: 1024.9px)" type="image/png">
            <source width="2000" height="496" srcset='assets/img/banners/data-setup-banner-desktop.webp'
                media="(min-width: 1025px)" type="image/webp">
            <source width="2000" height="496" srcset='assets/img/banners/data-setup-banner-desktop.png'
                media="(min-width: 1025px)" type="image/png">
            <img width="2000" height="496" src="assets/img/banners/data-setup-banner-desktop.png"
                alt="Data Setup Banner Image">
        </picture>
        <div class="banner-text-content page-section">
            <h1 class="header">{{ !!isIos ? 'IPHONE' : 'ANDROID' }} SMARTPHONE LTE INSTRUCTIONS:</h1>
            <h4 class="description">{{ !!isIos ? 'Set up your data' : 'Android Version 4.0 (Ice cream sandwich) & up'
                }}...</h4>
        </div>
    </section>
    <section class="data-setup-content-section page-section" [class.background-none]="!isTmo && !!isIos"
        *ngIf="!isGeneration">
        <h2 class="section-title">Setup your Phone</h2>
        <p class="sub-title">{{ !isTmo && !!isIos ? 'Make sure you are connected to a WiFi network and go to the
            following link on your iPhone:' : 'Check the following notes below before you start:' }}</p>
        <ng-container *ngIf="!!isTmo || ( !isTmo && !isIos )">
            <div class="flex bottom">
                <div class="image-part">
                    <img src="assets/img/tmo-first-thing.svg" width="64" height="64" alt="TMO First Thing Icon">
                </div>
                <div class="text-part">
                    <h5 class="title">First things first...</h5>
                    <p class="smaller desc">If you just activated your phone, are using a new phone, or took a recent
                        software update, please make sure to turn the phone off and back on with the FreeUp SIM
                        installed.</p>
                    <p class="smaller desc last">This ensures your phone will get its first set of programming direct
                        from the towers, and will force your phone to register quickly.</p>
                </div>
            </div>
            <div class="flex">
                <div class="image-part">
                    <img src="assets/img/tmo-second-thing.svg" width="64" height="64" alt="TMO Second Thing Icon">
                </div>
                <div class="text-part">
                    <h5 class="title">Secondly...</h5>
                    <p class="desc">Important data settings need to be programmed into your phone.</p>
                    <p class="desc last">This is like the key to the data portion of the network. Without this, your
                        mobile data will not work.</p>
                </div>
            </div>
            <div class="info-banner default-background white-note">
                <div class="flex">
                    <img src="assets/icon/banner-info-icon.svg" width="32" height="32" alt="Info Icon">
                    <div class="banner-content">
                        <h5 class="title">Note:</h5>
                        <ng-container *ngIf="!!isTmo">
                            <p class="smaller desc-a">Normally, <b>these settings will be programmed</b> into your
                                phone <b>automatically</b>.</p>
                            <p class="smaller desc-b">Depending on your phone model, you may get a text saying “We
                                see your phone does not have access to the internet or send MMS. Settings will be
                                sent to your handset.”</p>
                            <p class="smaller desc-a last">If you <b>do NOT get the settings automatically,</b>
                                please follow the instructions below to <b>manually enter the settings</b>.</p>
                        </ng-container>
                        <ng-container *ngIf="!isTmo && !isIos">
                            <p class="smaller desc-a">The following instructions are for most <b>Android
                                    devices</b>.</p>
                            <p class="smaller desc-b">While your phone’s menu may look different, the information
                                which goes into each of the fields is the same, no matter what model device you
                                have.</p>
                            <p class="smaller desc-a last">No data connection is necessary when entering these
                                settings but a data-capable device is required to surf the web and watch videos
                                online.</p>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="info-banner warning-background" *ngIf="!isTmo" [class.top]="!isIos">
            <div class="flex">
                <img src="assets/icon/banner-warning-icon.svg" width="32" height="32" alt="Warning Icon">
                <div class="banner-content">
                    <h5 class="title">Attention</h5>
                    <p class="smaller desc-a last">Phones which are <b>5G capable require</b> special data settings to
                        be able to use the <b>5G network</b>. <b>You must also turn on 5G through your account summary
                            page</b>.</p>
                </div>
            </div>
        </div>
    </section>
</div>